import { CarouselSection } from '@app/components/CarouselSection';
import { constants, Skeleton, Stack } from '@redbubble/design-system';

interface FanArtCardSkeletonProps {
  key: string;
}

export const FanArtCardSkeleton: React.FC<FanArtCardSkeletonProps> = ({
  key,
}) => {
  return (
    <CarouselSection.CarouselSlide key={key}>
      <Stack spacing="s" data-testid="fan-art-section-skeleton">
        <Skeleton ratio={constants.RATIO_SQUARE} animated roundedCorners />

        <Skeleton
          height={8 * 2}
          width={8 * 7 + 8 * (8 * Math.random())}
          animated
          roundedCorners
        />

        <Skeleton
          height={8 * 3}
          width={8 * 8 + 8 * (8 * Math.random())}
          animated
          roundedCorners
        />
      </Stack>
    </CarouselSection.CarouselSlide>
  );
};
